export default __webpack_public_path__ + "757b358f30f1d55369076c620ae3e2c5.svg";